import React, { useEffect, useMemo, useState } from 'react';
import {
  ChevronLeft,
  Plus,
} from 'react-bootstrap-icons';
import styles from './contact_detail_view.module.css';
import { CloseIcon, EditIcon, FacebookIcon, GlobeIcon, LinkdinIcon, MessageIcon, MoreIcon, PhoneIcon, SendIcon, TrashIcon, TwitterIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Cell, Column, Divider, Flex, Grid, Item, Link, Menu, MenuTrigger, Row, TableBody, TableHeader, TableView, ToastQueue, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { DeleteConfirmationDialog } from '../../finder/components/DeleteConfirmationDialog';
import { FPAData } from '../../../../infra/protected/FPA/FPAData';
import ContactTimelineView from './ContactTimelineView';
import RelatedContexts from './RelatedContexts';
import { useReefConfig } from '../../../../hooks/UseReefConfig';
import { getDownloadUrl } from '../../../../utils/ImagePathUtils';
import { useTranslation } from 'react-i18next';
interface IContactDetailViewProps {
  contact: any;
  contactDataRow: any;
  listOrganizationFolder: any;
  employees: any;
  contactStatusList: any;
  handleEmployeeClick: any;
  handleEmployerClick: any;
  handleEditClick: any;
  isPerson: any;
  handleContactDelete: any;
  navigationStack: any;
  handleBack: () => void;
  showCards?: boolean;
  handleAddEmployeeRelation: () => void;
  handleAddEmployerRelation: () => void;
  handleRemoveRelation: (relationId: string) => Promise<void> | void;
}
const ContactDetailView: React.FC<IContactDetailViewProps> = ({
  contact,
  contactDataRow,
  listOrganizationFolder,
  employees,
  contactStatusList,
  handleEmployeeClick,
  handleEmployerClick,
  handleEditClick,
  isPerson,
  handleContactDelete,
  navigationStack,
  handleBack,
  showCards,
  handleAddEmployeeRelation,
  handleAddEmployerRelation,
  handleRemoveRelation,
}) => {
  const { contactSettings } = usePreloadAssets();
  const [employeesData, setEmployeesData] = useState<any>([]);
  const { store, mainService } = useDependency();
  const [result, setResult] = useState<any>([]);
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`contact_detail.${key}`, { ns: 'contacts' });
  useEffect(() => {
    setEmployeesData(employees);
  }, [employees])

  useEffect(() => {
    const data = {
      ...contact,
      ADDRESSES: Array.isArray(contact?.ADDRESSES)
        ? contact.ADDRESSES.map((address: any) => address.ADDRESS)
        : contact?.ADDRESSES?.ADDRESS
          ? [contact.ADDRESSES.ADDRESS]
          : [],
      CONTACTS: Array.isArray(contact?.CONTACTS)
        ? contact.CONTACTS.map((contact: any) => contact.CONTACT)
        : contact?.CONTACTS?.CONTACT
          ? [contact.CONTACTS.CONTACT]
          : [],
      DGROUPS: Array.isArray(contact?.DGROUPS)
        ? contact.DGROUPS.map((contact: any) => contact.DGROUP)
        : contact?.DGROUPS?.DGROUP
          ? [contact.DGROUPS.DGROUP]
          : [],
      RELATIONS: Array.isArray(contact?.RELATIONS)
        ? contact.RELATIONS.map((contact: any) => contact.RELATION)
        : contact?.RELATIONS?.RELATION
          ? [contact.RELATIONS.RELATION]
          : [],
      FOLDERS: Array.isArray(contact?.FOLDERS)
        ? contact.FOLDERS.map((address: any) => address.FOLDER)
        : contact?.FOLDERS?.FOLDER
          ? [contact.FOLDERS.FOLDER]
          : [],
      EMPLOYMENTS: Array.isArray(contact?.EMPLOYMENTS)
        ? contact.EMPLOYMENTS.map((employment: any) => employment.COMPANY)
        : contact?.EMPLOYMENTS?.COMPANY
          ? [contact.EMPLOYMENTS.COMPANY]
          : [],
      INDUSTRIES: Array.isArray(contact?.INDUSTRIES)
        ? contact.INDUSTRIES.map((Industry: any) => Industry.INDUSTRY)
        : contact?.INDUSTRIES?.INDUSTRY
          ? [contact.INDUSTRIES.INDUSTRY]
          : [],
      DOCUMENT: Array.isArray(contact?.DOCUMENT)
        ? contact.DOCUMENT.map((document: any) => document)
        : contact?.DOCUMENT
          ? [contact.DOCUMENT]
          : [],
    };
    setResult(data)

  }, [contact])

  const handleFolderClick = (folderId: any) => {
    invokeFinderApp(folderId)
  }

  const handleEmployeeListClick = (id: any) => {
    const filteredEmployee = employeesData.find((x: any) => x.id === id)
    handleEmployeeClick(filteredEmployee.contact)
  }

  const handleEmployerListClick = (id: any) => {
    handleEmployerClick(id)
  }

  // Required fields to always display
  const requiredFields = ["Mobil", "E-mail", "Telefon"];
  const requiredIcons = ["Facebook", "Twitter", "Linkedin"];
  const labelMap: Record<string, string> = {
    "Mobil": "Mobile",
    "Telefon": "Phone"
  };

  const getContactDetailsUI = (contact: any): JSX.Element => {
    const contactDetails: Record<string, { value: string | undefined; className: string }> = {};
    // Extract contacts from response

    const contactsArray: any[] = result.CONTACTS;
    // Organize contacts based on type
    if (!result || !contactsArray) {
      return (<View></View>)
    }
    contactsArray.filter((x: any) => x.isPrimary === '1').forEach((c) => {
      const typeInfo = contactSettings[c.type];
      if (typeInfo) {
        contactDetails[typeInfo.name === 'Fakturační e-mail' ? "E-mail" : typeInfo.name] = { value: c.content, className: typeInfo.className };
      }
    });

    // Prioritize direct fields (fallback to array values if unavailable)
    contactDetails["Mobil"] = { value: contactDetails["Mobil"]?.value, className: "mobile-parent1" };
    contactDetails["E-mail"] = { value: contactDetails["E-mail"]?.value, className: "e-mail-parent1" };
    contactDetails["Telefon"] = { value: contactDetails["Telefon"]?.value, className: "phone-parent1" };

    // Ensure required fields always appear
    requiredFields.forEach((field) => {
      if (!(field in contactDetails)) {
        contactDetails[field] = { value: "N/A", className: `${field.toLowerCase()}-parent` };
      }
    });

    // Generate UI elements
    return (
      <View UNSAFE_className={styles['frame-group']}>
        {Object.entries(contactDetails)
          .filter(([label]) => requiredFields.includes(label)) // Only keep required fields
          .map(([label, { value, className }]) => {
            const displayLabel = labelMap[label] || label;
            return (
              <View key={label} UNSAFE_className={styles[className]}>
                {value ? (
                  <>
                    <View UNSAFE_className={styles.mobile}>{displayLabel}</View>
                    <View UNSAFE_className={className === 'e-mail-parent1' ? styles.divEmail : styles.div}>{value}</View>
                  </>
                ) : (
                  <>
                    <View UNSAFE_className={styles.mobile} UNSAFE_style={{ width: '130px' }}>
                      {displayLabel}
                    </View>
                    <View UNSAFE_className={styles.div} UNSAFE_style={{ width: '130px' }}></View>
                  </>
                )}
              </View>
            );
          })}
      </View>
    );
  };

  const getIconsDetailsUI = (contact: any): JSX.Element => {
    const contactDetails: Record<string, { value: string | undefined; className: string, icon?: JSX.Element }> = {};

    // Extract contacts from response
    const contactsArray: any[] = [];

    if (contact.CONTACTS) {
      if (Array.isArray(contact.CONTACTS)) {
        // Handle case where CONTACTS is an array of objects with CONTACT property
        contactsArray.push(...contact.CONTACTS.map((item: any) => item.CONTACT));
      } else if (contact.CONTACTS.CONTACT) {
        // Handle case where CONTACTS.CONTACT is an array 
        if (Array.isArray(contact.CONTACTS.CONTACT)) {
          contactsArray.push(...contact.CONTACTS.CONTACT);
        } else {
          // Handle case where CONTACTS.CONTACT is a single object
          contactsArray.push(contact.CONTACTS.CONTACT);
        }
      }
    }

    // Organize contacts based on type
    contactsArray.forEach((c) => {
      const typeInfo = contactSettings[c.type];
      if (typeInfo) {
        contactDetails[typeInfo.name] = { value: c.content, className: typeInfo.className };
      }
    });

    // Set social media icons with correct values and icons
    contactDetails["Facebook"] = {
      value: contactDetails["Facebook"]?.value,
      className: "icon_facebook", // Fixed className (was "icon_twitter")
      icon: <FacebookIcon size={30} />  // Fixed icon (was TwitterIcon)
    };

    contactDetails["Twitter"] = {
      value: contactDetails["Twitter"]?.value,
      className: "icon_twitter", // Fixed className (was "icon_facebook")
      icon: <TwitterIcon size={30} />
    };

    contactDetails["LinkedIn"] = {
      value: contactDetails["LinkedIn"]?.value,
      className: "icon_linkedin",
      icon: <LinkdinIcon size={30} />
    };

    // Ensure required fields always appear
    requiredIcons.forEach((field) => {
      if (!(field in contactDetails)) {
        contactDetails[field] = {
          value: undefined, // Changed from "N/A" to undefined for better link handling
          className: `icon_${field.toLowerCase()}`
        };
      }
    });

    // Generate UI elements with proper link handling
    return (
      <View UNSAFE_className={styles['iconsstates2']}>
        {Object.entries(contactDetails).map(([label, { value, className, icon }]) => (
          <View key={label} UNSAFE_className={className}>
            {value ? (
              <Link target='_blank' UNSAFE_className={styles[`${className}_active`]} href={value}>{icon}</Link>
            ) : (
              <span>{icon}</span> // When no link is available, just show the icon
            )}
          </View>
        ))}
      </View>
    );
  };

  const handleEmployeeChange = (search: any) => {
    search = search.trim();

    if (search === "") {
      setEmployeesData(employees);
      return;
    }

    const filteredEmployees = employeesData.filter((x: any) =>
      x.name1.toLowerCase().includes(search.toLowerCase()) ||
      x.name3.toLowerCase().includes(search.toLowerCase())
    );

    setEmployeesData(filteredEmployees);
  };

  const addStatusColor = (type: string) => {
    let customStatusName = '';
    if (!contact.FOLDERS) {
      return;
    }
    if (!Array.isArray(contact.FOLDERS)) {
      customStatusName = contact.FOLDERS?.FOLDER?.customStateName;
    } else {
      const filteredFolder = contact.FOLDERS.find((item: any) => item.FOLDER.type === type);
      customStatusName = filteredFolder?.FOLDER?.customStateName;
    }
    if (customStatusName != '') {
      const statusObj = contactStatusList.find((obj: any) => obj.name === customStatusName);
      return statusObj?.color;
    } else {
      return ''
    }
  };
  let [isOpen, setOpen] = React.useState(false);

  const getSelectedItm = () => {
    const selectedItem = new FPAData();
    selectedItem.id = contact.folderId;
    return selectedItem
  }

  const { baseUrl, loginInfo } = useReefConfig();
  const getProfileUrl = () => {
    if (result.DOCUMENT && result.DOCUMENT.length > 0) {
      const imageUrl = getDownloadUrl(result.DOCUMENT[0].documentId, baseUrl, store.Server, store.SessionId);
      return imageUrl
    }
    return '/assets/images/avatar--desktop--light@2x.png'
  }

  const copyUrl = () => {
    const url = `${window.location.origin}/contacts?id=${contact?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(t('link_copied_to_clipboard', { ns: 'layout_components' }), { timeout: 1000 });
  }

  return (
    <View>
      <Flex direction={'column'} UNSAFE_className={styles.detail}>
        <Flex justifyContent={'space-between'}>
          <View UNSAFE_className={styles['frame-parent']}>
            <View UNSAFE_className={styles['icon-contacts-parent']}>
              {((navigationStack && navigationStack.length > 0) || (!showCards)) && 
                <ActionButton isQuiet onPress={handleBack}>
                  <ChevronLeft size={20} />
                </ActionButton>
              }
              <b className={styles['adam-novotn']}><span className={
                +contactDataRow?.folderCount > 0 ? styles.contact_icon_orange : styles.contact_icon_grey
              }>
                {/* <ContactIcon size={20} color={'#ff9800'} /> */}
                <Avatar src={getProfileUrl()} size={26} /></span> <span style={{ fontFamily: 'Adobe Clean', fontSize: '20px', fontWeight: '700' }}>{contact?.name3} {contact?.name1}</span></b>
            </View>
          </View>
          <Flex direction={'row'}>
            <View UNSAFE_className={styles['tag-parent']}>
              {listOrganizationFolder && listOrganizationFolder.map(((folder: any) => (
                <View key={folder.folderId} UNSAFE_className={styles.tag} UNSAFE_style={{ backgroundColor: addStatusColor(folder.folderTypeId) }}>
                  <View UNSAFE_className={styles.mobile}>
                    <a onClick={() => handleFolderClick(folder.folderId)}>
                      {folder.folderTypeName}
                    </a>
                  </View>
                </View>
              )))}
            </View>
            <View UNSAFE_className={styles.iconsstates2}>
              <ActionButton isQuiet onPress={() => handleEditClick(true)}>
                <EditIcon size={24} />
              </ActionButton>
              <ActionButton isQuiet onPress={() => setOpen(true)}>
                <TrashIcon size={24} />
              </ActionButton>
              {/* <ActionButton isQuiet>
                <MoreIcon size={24} />
              </ActionButton> */}
              <MenuTrigger>
                <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
                <Menu onAction={copyUrl}>
                  <Item key={'copy'}>Copy Link</Item>
                </Menu>
              </MenuTrigger>
            </View>
          </Flex>
        </Flex>
        <Grid
          columns={['80%', '20%']}
          rows={['auto']}
          marginTop={15}
        >
          <View marginTop={10} UNSAFE_className={styles['frame-group']}>
            {result && getContactDetailsUI(contact)}
          </View>
          {result && getIconsDetailsUI(contact)}
        </Grid>
        {showCards &&
          <Grid
            columns={['1fr', '1fr']}
            rows={['auto']}
            marginTop={22}
            gap={'size-100'}
          >
            <View UNSAFE_className={styles['frame-container']}>
              <View UNSAFE_className={styles['mobile-parent']}>
                <View UNSAFE_className={styles.mobile}>{_t('last_modification')}</View>
                <View UNSAFE_className={styles['alena-janik']}>
                  {moment(contact.modified).format('MM/DD/YYYY')}
                </View>
              </View>
              <View UNSAFE_className={styles['phone-parent']}>
                <View UNSAFE_className={styles.mobile}>{_t("modified_by")}</View>
                <View UNSAFE_className={styles['alena-janik']}>{contact.modifiedByName}</View>
              </View>
              <View UNSAFE_className={styles['created-parent']}>
                <View UNSAFE_className={styles.mobile}>{_t("created")}</View>
                <View UNSAFE_className={styles.div3}>
                  {moment(contact.created).format('MM/DD/YYYY')}
                </View>
              </View>
            </View>
          </Grid>
        }
      </Flex>
      <Divider marginTop={10} marginBottom={5} size='M' />
      <Grid
        columns={['1fr', '1fr']}
        marginTop={22}
        gap={'size-100'}
      >
        <View>
          <b className={styles.address}>{_t('contact_details')}</b>
          <TableView
            overflowMode="wrap"
            density="spacious"
            UNSAFE_className='tblContactLayoutComponent'
            marginTop={10}
          >
            <TableHeader>
              <Column width={140}>{_t('contact_type')}</Column>
              <Column>{_t('details')}</Column>
            </TableHeader>
            <TableBody>
              <Row>
                <Cell>
                  <div style={{ display: 'flex', alignItems: 'start' }}>
                    <MessageIcon size={18} />
                    <span style={{ marginLeft: '8px' }}>{_t('email')}</span>
                  </div>
                </Cell>
                <Cell>
                  {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '1').map((email: any) => (
                    <div>
                      {email.typeName}: <Link href={`mailto:${email.content}`}> {email.content}</Link>
                    </div>
                  ))}
                </Cell>
              </Row>
              <Row>
                <Cell>
                  <div style={{ display: 'flex', alignItems: 'start' }}>
                    <PhoneIcon size={18} />
                    <span style={{ marginLeft: '8px' }}>{_t('phone')}</span>
                  </div>
                </Cell>
                <Cell>
                  {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '3' || x.typeType === '2' || x.typeType
                    === '4').map((phone: any) => (
                      <div>
                        {phone.typeName}: <Link href={`tel:${phone.contact}`}> {phone.content}</Link>
                      </div>
                    ))}
                </Cell>
              </Row>
              <Row>
                <Cell>
                  <div style={{ display: 'flex', alignItems: 'start' }}>
                    <GlobeIcon size={18} />
                    <span style={{ marginLeft: '8px' }}>{_t('web')}</span>
                  </div>
                </Cell>
                <Cell>
                  <div>
                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '5').map((phone: any) => (
                      <div>
                        {phone.typeName}: <Link href={phone.content && phone.content.startsWith('http') ? phone.content : `https://${phone.content}`} target="_blank" rel="noopener noreferrer">{phone.content}</Link>
                      </div>
                    ))}
                  </div>
                </Cell>
              </Row>
              <Row>
                <Cell>
                  <div style={{ display: 'flex', alignItems: 'start' }}>
                    <SendIcon size={18} />
                    <span style={{ marginLeft: '8px' }}>{_t('social_media')}</span>
                  </div>
                </Cell>
                <Cell>
                  {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '9' || x.typeType === '10' || x.typeType
                    === '11').map((phone: any) => (
                      <div>
                        {phone.typeName}: <Link href={phone.content && phone.content.startsWith('http') ? phone.content : `https://${phone.content}`} target="_blank" rel="noopener noreferrer">{phone.content}</Link>
                      </div>
                    ))}
                </Cell>
              </Row>
            </TableBody>
          </TableView>
          {result && result.ADDRESSES && result.ADDRESSES.length > 0 &&
            <View marginTop={15} UNSAFE_className={styles['address-parent']}>
              <b className={styles.address}>{_t('address')}</b>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.addressValue}>
                  <p className={styles.bristol}>{result.ADDRESSES[0].street}</p>
                  <p className={styles.bristol}>{result.ADDRESSES[0].cityName}</p>
                  <p className={styles.bristol}>{result.ADDRESSES[0].zipName}</p>
                </View>
              </View>
            </View>
          }
          {employeesData && !isPerson &&
            <View marginTop={10} UNSAFE_className={styles['greybox-parent']}>
              <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                <View UNSAFE_className={styles.address}><b>{_t('employees')}</b></View>
                <Flex>
                  <ActionButton isQuiet aria-label="Add" onPress={handleAddEmployeeRelation}>
                    <Plus size={20} />
                  </ActionButton>
                </Flex>
              </Flex>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  {employeesData.map((employee: any) => ((
                    <Flex marginBottom={10} direction={'row'} gap={'size-100'} UNSAFE_className={styles["relation-row"]}>
                      <View UNSAFE_className={styles["employee-name"]}>
                        <Link isQuiet onPress={() => handleEmployeeListClick(employee.id)}>{`${employee.name3} ${employee.name1}`}</Link>
                      </View>
                      <View UNSAFE_className={styles["employee-details"]}>
                        {employee.departmentName && ' | '}
                        {employee.positionName}
                        {employee.departmentName && ` (${employee.departmentName})`}
                      </View>
                      <View UNSAFE_className={styles["relation-row-action"]}>
                        <ActionButton
                          isQuiet
                          aria-label="Remove employee"
                          onPress={() => handleRemoveRelation(employee.id)}
                          isDisabled={!employee?.id}
                        >
                          <CloseIcon size={14} />
                        </ActionButton>
                      </View>

                    </Flex>
                  )))}
                </View>
              </View>
            </View>
          }
          {employeesData && isPerson &&
            <View marginTop={10} UNSAFE_className={styles['greybox-parent']}>
              <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                <View UNSAFE_className={styles.address}><b>{_t('employers')}</b></View>
                <Flex gap="size-100">
                  <ActionButton isQuiet aria-label="Add" onPress={handleAddEmployerRelation}>
                    <Plus size={20} />
                  </ActionButton>
                </Flex>
              </Flex>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  {result && result.EMPLOYMENTS?.map((employee: any) => (
                    <Flex marginBottom={10} direction={'row'} gap={'size-100'} UNSAFE_className={styles["relation-row"]}>
                      <View UNSAFE_className={styles["employee-name"]}>
                        <Link isQuiet onPress={() => handleEmployerListClick(employee.id)}>{`${employee.name}`}</Link>
                      </View>
                      <View UNSAFE_className={styles["employee-details"]}>
                        {employee.positionInfo} {employee.departmentName && ' | '}
                        {employee.positionName}
                        {employee.departmentName && ' | '}
                        {employee.departmentName}
                      </View>
                      <View UNSAFE_className={styles["relation-row-action"]}>
                        <ActionButton
                          isQuiet
                          aria-label="Remove employer"
                          onPress={() => handleRemoveRelation(employee.id)}
                          isDisabled={!employee?.id}
                        >
                          <CloseIcon size={14} />
                        </ActionButton>
                      </View>
                    </Flex>
                  ))}
                </View>
              </View>
            </View>
          }
          {result && result.RELATIONS?.length > 0 &&
            <View marginTop={10} UNSAFE_className={styles['greybox-parent']}>
              <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                <View UNSAFE_className={styles.address}><b className={styles.address}>{_t('related_companies')}</b></View>
                <Flex gap="size-100">
                  {/* <ActionButton isQuiet aria-label="Filter">
                  <Filter/>
                </ActionButton> */}
                  <ActionButton isQuiet aria-label="Add">
                    <Plus size={20} />
                  </ActionButton>
                </Flex>
              </Flex>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  {result.RELATIONS.flat()
                    .map((relation: any) => {
                      // Determine the other company's details dynamically
                      const isMainCompanyContact1 = relation.contact1Id === contact.id;
                      const isMainCompanyContact2 = relation.contact2Id === contact.id;

                      if (!isMainCompanyContact1 && !isMainCompanyContact2) return null;

                      const relatedCompany = isMainCompanyContact1
                        ? { id: relation.contact2Id, name: relation.contact2Name1, type: relation.typeName2 }
                        : { id: relation.contact1Id, name: relation.contact1Name1, type: relation.typeName1 };

                      return (
                        <Flex marginBottom={10} direction={'row'} gap={'size-100'} key={relatedCompany.id}>
                          <View UNSAFE_className={styles["employee-details"]}>
                            <Link isQuiet onPress={() => handleEmployerListClick(relatedCompany.id)}>
                              {relatedCompany.name}
                            </Link>
                            {relatedCompany.type && ' | '}
                            {relatedCompany.type}
                          </View>
                        </Flex>
                      );
                    })}

                </View>
              </View>
            </View>
          }
          <RelatedContexts contact={contact} />
        </View>
        <View flex>
          <ContactTimelineView contactId={contact.id} selectedItem={getSelectedItm()} contactStatusList={contactStatusList} />
        </View>
      </Grid>
      <DeleteConfirmationDialog
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onConfirm={() => handleContactDelete(contact)}
        itemName={contact?.name1}
      />
    </View>
  );
};

export default ContactDetailView;
